import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/concatMap';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

// Services
import { SidebarService } from '../../services/sidebar.service';
import { PermissionGroupService } from '../../services/permissionGroup.service';
import { LOGO_COMUNIDAD_KIUNGO, LOGO_COMUNIDAD_KASTOR, HELP_CENTER_URL } from '../../app.service';
import { CommunityService } from '../../services/community.service';
import { AppBase } from '../../app-base';
import { UserService } from '../../services/user.service';

// Menu
declare var require: any;
const jsonMenu = require('../../../assets/menu/menu.json');

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass'],
})
export class SidebarComponent extends AppBase implements OnInit, OnDestroy {

  // variables
  private componentDestroyed: Subject<boolean> = new Subject();
  public sidebarStatus = true;
  public subscriptionSidebar: Subscription;
  public subscriptionRoute: Subscription;
  public subscriptionDataCommunity: Subscription;
  public communityInSession: string;
  public codeCommunityInSession: string;
  public imageUser = null;
  public imageCommunity: string;
  public addressCommunity: string;
  public menu = null;
  public urlActive = null;
  public emailUser = null;
  public permissionUser = [];
  public help = false;
  public logoCommunity = LOGO_COMUNIDAD_KASTOR;
  public view = false;
  public myObservable = new Subject<boolean>();
  public hola = true;

  constructor(private _sidebarService?: SidebarService,
              private _communityService?: CommunityService,
              private _userService?: UserService,
              public router?: Router,
              private _permissionGroupService?: PermissionGroupService) {
    super();
    this._sidebarService.changeRoute(router.url);
  }

  ngOnInit() {
    this.initData();
    if (this.currentUser) {
      if (this.currentUser.realm === 'kiungo') {
        this.logoCommunity = LOGO_COMUNIDAD_KIUNGO;
      }
    }

    this.router.events.subscribe((val: any) => {
      // see also
      if (val.url) {
        this._sidebarService.changeRoute(val.url);
      }
    });

    this.menu = jsonMenu.menu;
    // oyente
    this.subscriptionSidebar = this._sidebarService.observableStateSidebar$
      .subscribe(
        res => {
          this.sidebarStatus = !this.sidebarStatus;
        });

    // oyente

    // oyente data comunidad
    this._sidebarService.observableDataCommunity$
      .subscribe(
        res => {
          this.initData();
        });

    // oyente

    const group = this._permissionGroupService.userPermission();

    group.concatMap(permissions => {
      this.permissionUser = permissions;
      return this._sidebarService.observableRoute$;
    })
      .takeUntil(this.componentDestroyed)
      .subscribe(
        res => {
          this.urlActive = res !== null ? res : this.router.url;
          this.menu.forEach((item, i) => {
            let element = null;
            let list = null;
            let subElement = null;
            let listSub = null;
            let subElement3 = null;
            let listSub3 = null;
            let belongs = false;
            if (item.entity) {
              element = document.getElementById(`element_${i}`);
              list = document.getElementById(item.entity);
              item.sub.forEach((subm, j) => {
                if (subm.link === this.urlActive) {
                  belongs = true;
                }
                if (subm.entity) {
                  if (subm.sub.length > 0) {
                    subm.sub.forEach((subm2, k) => {
                      if (subm2.link === this.urlActive) {
                        belongs = true;
                        subElement = document.getElementById(`element2_${j}`);
                        listSub = document.getElementById(subm.entity);
                      }
                      if (subm2.entity) {
                        subElement3 = document.getElementById(`subLevel3_${k}`);
                        listSub3 = document.getElementById(subm2.entity);
                        if (subm2.sub.length > 0) {
                          subm2.sub.forEach((subm3, n) => {
                            if (subm3.link === this.urlActive) {
                              belongs = true;
                              subElement = document.getElementById(`element2_${j}`);
                              listSub = document.getElementById(subm.entity);
                            }
                          });
                        }
                      }
                    });
                  }
                }
              });
            }
            if (!belongs) {
              if (element && list) {
                element.classList.add('collapsed');
                element.setAttribute('aria-expanded', 'false');
                list.classList.remove('show');
                if (subElement && listSub) {
                  subElement.classList.add('collapsed');
                  subElement.setAttribute('aria-expanded', 'false');
                  listSub.classList.remove('show');
                  if (subElement3 && listSub3) {
                    subElement3.classList.add('collapsed');
                    subElement3.setAttribute('aria-expanded', 'false');
                    listSub3.classList.remove('show');
                  }
                }
              }
            } else {
              if (element && list) {
                element.classList.remove('collapsed');
                element.setAttribute('aria-expanded', 'true');
                list.classList.add('show');
                if (subElement && listSub) {
                  subElement.classList.remove('collapsed');
                  subElement.setAttribute('aria-expanded', 'true');
                  listSub.classList.add('show');
                  if (subElement3 && listSub3) {
                    subElement3.classList.remove('collapsed');
                    subElement3.setAttribute('aria-expanded', 'true');
                    listSub3.classList.add('show');
                  }
                }
              }
            }
          });
        });

    setTimeout(() => {
      this._sidebarService.changeRoute(this.urlActive);
    }, 1000);
  }

  initData() {
    this._communityService.getCommunityById(this.currentUser.community_id)
    .subscribe(response => {
      this.communityInSession = response.community.name;
      this.codeCommunityInSession = response.community.id_number;
    });

  this._communityService.getImageCommunity(this.currentUser.community_id)
    .subscribe(imageCommunity => {
      this.imageCommunity = imageCommunity && imageCommunity.value ? imageCommunity.value : null;
    });

  this._communityService.getAddressCommunity(this.currentUser.community_id)
    .subscribe(addressCommunity => {
      this.addressCommunity = addressCommunity && addressCommunity.value ? addressCommunity.value : null;
    });

  this._userService.getUserById(this.currentUser.user_id).subscribe(user => {
    this.emailUser = user.email;
    this.imageUser = user.user_img;
  });
  }

  // activamos y desactivamos sidebar
  public toggleClass(): void {
    this.sidebarStatus = !this.sidebarStatus;
  }

  // revisamos rutas activas para modulo
  public validateRoute(modules: any, negation: boolean): boolean {
    let valid = false;
    if (modules.length > 0) {
      modules.forEach((sub, _i) => {
        if (this.urlActive === sub.link) {
          valid = true;
        }
        if (sub.sub.length > 0) {
          sub.sub.forEach(subm => {
            if (this.urlActive === subm.link) {
              valid = true;
            }
            if (subm.sub.length > 0) {
              subm.sub.forEach(subm2 => {
                if (this.urlActive === subm2.link) {
                  valid = true;
                }
              });
            }
          });
        }
      });
    }
    return valid;
  }

  validPermission(permission) {
    const permissionValid = this.permissionUser.find(x => x === permission);
    if (permissionValid) {
      return true;
    }
    return false;
  }

  ngOnDestroy() {
    this.componentDestroyed.next(true);
    this.componentDestroyed.complete();
  }

  public goToHelpCenter(): void {
    window.open(HELP_CENTER_URL, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/sidebar/sidebar.component.ts